"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));

var _setInterval2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-interval"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _bind = _interopRequireDefault(require("lodash/bind"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _times = _interopRequireDefault(require("@spothero/icons/times"));

var _dom = _interopRequireDefault(require("@spothero/utils/dom"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _Portal = _interopRequireDefault(require("../Portal/Portal"));

var Tooltip =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Tooltip, _Component);

  function Tooltip(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Tooltip);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Tooltip).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onCloseClick", function (evt) {
      _this.hide();
    });
    _this._isArrowAdjusted = false;
    return _this;
  }

  (0, _createClass2.default)(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          triggerSelector = _this$props.triggerSelector,
          updateOnMove = _this$props.updateOnMove,
          closeOnBodyClick = _this$props.closeOnBodyClick;
      this._trigger = _dom.default.el(triggerSelector);

      this._positionTooltip();

      _dom.default.addClass(this._container, 'Tooltip-showing');

      if (updateOnMove) {
        this._container.style.position = 'fixed';
        this._scrollInterval = (0, _setInterval2.default)((0, _bind.default)(this._positionTooltip, this), 100);
      }

      if (closeOnBodyClick) {
        document.addEventListener('click', this._onCloseClick);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props2 = this.props,
          updateOnMove = _this$props2.updateOnMove,
          closeOnBodyClick = _this$props2.closeOnBodyClick;

      if (updateOnMove) {
        clearInterval(this._scrollInterval);
      }

      if (closeOnBodyClick) {
        document.removeEventListener('click', this._onCloseClick);
      }
    }
  }, {
    key: "_positionTooltip",
    value: function _positionTooltip() {
      if (!this._trigger) {
        return;
      }

      var _this$props3 = this.props,
          position = _this$props3.position,
          tipOffset = _this$props3.tipOffset,
          updateOnMove = _this$props3.updateOnMove,
          adjustArrow = _this$props3.adjustArrow;

      var _this$_trigger$getBou = this._trigger.getBoundingClientRect(),
          clientTop = _this$_trigger$getBou.top,
          clientLeft = _this$_trigger$getBou.left,
          clientRight = _this$_trigger$getBou.right,
          clientBottom = _this$_trigger$getBou.bottom,
          width = _this$_trigger$getBou.width,
          height = _this$_trigger$getBou.height;

      var tooltipWidth = this._container.offsetWidth;
      var tooltipHeight = this._container.offsetHeight;

      var _DOMUtils$getDocument = _dom.default.getDocumentOffset(this._trigger),
          documentTop = _DOMUtils$getDocument.top,
          documentLeft = _DOMUtils$getDocument.left;

      var top = updateOnMove ? clientTop : documentTop;
      var right = updateOnMove ? clientRight : documentLeft + width;
      var bottom = updateOnMove ? clientBottom : documentTop + height;
      var left = updateOnMove ? clientLeft : documentLeft;
      var containerMid = position === 'top' || position === 'bottom' ? tooltipWidth / 2 : tooltipHeight / 2;
      var bodyWidth = document.body.clientWidth;
      var adjuster = 5;
      var newTop = 0;
      var newLeft = 0;

      switch (position) {
        case 'top':
          newTop = top - tooltipHeight - tipOffset;
          newLeft = left + width / 2 - containerMid;
          break;

        case 'right':
          newTop = top + height / 2 - containerMid;
          newLeft = right + tipOffset;
          break;

        case 'bottom':
          newTop = bottom + tipOffset;
          newLeft = left + width / 2 - containerMid;
          break;

        case 'left':
          newTop = top + height / 2 - containerMid;
          newLeft = left - tooltipWidth - tipOffset;
          break;
      } // adjust tooltip position if off the left side of the screen


      var adjustedLeft = newLeft < 0 ? adjuster : newLeft; // adjust tooltip position if off the right side of the screen

      if (tooltipWidth > bodyWidth - adjustedLeft) {
        adjustedLeft = bodyWidth - tooltipWidth - adjuster;
      }

      this._container.style.top = "".concat(newTop, "px");
      this._container.style.left = "".concat(adjustedLeft, "px");

      if (adjustArrow && !this._isArrowAdjusted && adjustedLeft !== newLeft && (position === 'top' || position === 'bottom')) {
        this._arrow.style.left = "".concat(this._arrow.getBoundingClientRect().left + (newLeft - adjustedLeft), "px");
        this._isArrowAdjusted = true;
      }
    }
    /**
     * Hides the Tooltip programmatically and fires the `onHidden` callback when done.
     *
     * @public
     * @returns {void}
     */

  }, {
    key: "hide",
    value: function hide() {
      var _this2 = this;

      if (_dom.default.hasClass(this._container, 'Tooltip-showing')) {
        _dom.default.removeClass(this._container, 'Tooltip-showing');

        (0, _setTimeout2.default)(function () {
          _this2.props.onHidden();
        }, 250);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props4 = this.props,
          className = _this$props4.className,
          containerClassName = _this$props4.containerClassName,
          position = _this$props4.position,
          showClose = _this$props4.showClose,
          children = _this$props4.children;
      var classes = (0, _classnames.default)('Tooltip', "Tooltip-".concat(position), {
        'Tooltip-no-close': !showClose
      }, className);
      return _react.default.createElement(_Portal.default, {
        className: containerClassName
      }, _react.default.createElement("div", {
        ref: function ref(node) {
          _this3._container = node;
        },
        className: classes,
        role: "tooltip"
      }, _react.default.createElement("div", {
        ref: function ref(node) {
          _this3._arrow = node;
        },
        className: "Tooltip-arrow"
      }), _react.default.createElement("div", {
        className: "Tooltip-content"
      }, children, showClose && _react.default.createElement(_Button.default, {
        className: "Tooltip-close",
        onClick: this._onCloseClick
      }, _react.default.createElement(_times.default, null)))));
    }
  }]);
  return Tooltip;
}(_react.Component);

exports.default = Tooltip;
(0, _defineProperty2.default)(Tooltip, "defaultProps", {
  position: 'top',
  showClose: true,
  tipOffset: 0,
  adjustArrow: true
});